module.exports = __webpack_public_path__ + "img/Success-Illustration.e300eecb.png";